import { useOverlays } from "contexts/OverlayContext";
import { ManualInvoiceCreationDrawer } from "./ManualInvoiceCreationDrawer";

export const ManualInvoiceCreationDrawerWrapper = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo("manualInvoiceCreation");

    if (!overlayInfo) {
        return null;
    }

    return (
        <ManualInvoiceCreationDrawer
            open={!overlayIsClosing}
            onClose={closeOverlay}
            initialRows={overlayInfo.data?.initialRows}
        />
    );
};
